<script setup lang="ts">
/**
 * 顶层 layout 容器:
 * - 启动时跑一次 auth.bootstrap()(localStorage 有 token 就拉 /me 校验);
 * - 同时安装 WS 路由 (installWebSocket), watch token 自动起停 WS;
 * - bootstrap 完成前不渲染 RouterView, 避免守卫误判刷新即"未登录"。
 * - 全局 Toast 永远挂在顶层。
 */

import { onMounted, ref } from 'vue'

import { useAuthStore } from '@/stores/auth'
import { installWebSocket } from '@/composables/useWebSocket'
import { installRouteSync } from '@/composables/useRouteSync'
import Toast from '@/components/common/Toast.vue'
import InstallHint from '@/components/common/InstallHint.vue'

const auth = useAuthStore()
const ready = ref(false)

// 在任何路由渲染之前安装 WS 路由 ——
// installWebSocket 内部 watch(auth.token, immediate: true) 会自动 connect。
// installRouteSync watch lobby.me.room_id 把 "我在哪个房间" 映射到路由。
installWebSocket()
installRouteSync()

onMounted(async () => {
  await auth.bootstrap()
  ready.value = true
})
</script>

<template>
  <div class="min-h-dvh w-full">
    <RouterView v-if="ready" />

    <div
      v-else
      class="min-h-dvh flex items-center justify-center text-neutral-600 text-xs uppercase tracking-widest"
    >
      Loading…
    </div>

    <Toast />
    <InstallHint />
  </div>
</template>
